import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ReasonsDifferencesPage } from './reasons-differences.page';

const routes: Routes = [
  {
    path: '',
    component: ReasonsDifferencesPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ReasonsDifferencesPage]
})
export class ReasonsDifferencesPageModule {}
